import { call, put, takeLatest } from 'redux-saga/effects';

import * as api from '../api/customCards';
import {
  addMagentoCard,
  addMagentoCardFailed,
  addMagentoCardSucceeded,
  editMagentoCard,
  editMagentoCardFailed,
  editMagentoCardSucceeded,
  getMagentoCardById,
  getMagentoCardByIdFailed,
  getMagentoCardByIdSucceeded,
  getMagentoCards,
  getMagentoCardsFailed,
  getMagentoCardsSucceeded,
  removeMagentoCard,
  removeMagentoCardFailed,
  removeMagentoCardSucceeded,
  testMagentoCard,
  testMagentoCardFailed,
  testMagentoCardSucceeded,
} from '../reducers/sections/magentoCards';

export const magentoCards = [
  takeLatest(
    getMagentoCardById.toString() as any,
    genWithPromise(
      api.getCustomCardById,
      getMagentoCardByIdSucceeded,
      getMagentoCardByIdFailed,
    ),
  ),
  takeLatest(
    getMagentoCards.toString() as any,
    genWithPromise(
      api.getCustomCards,
      getMagentoCardsSucceeded,
      getMagentoCardsFailed,
    ),
  ),
  takeLatest(
    testMagentoCard.toString() as any,
    genWithPromise(
      api.testCustomCard,
      testMagentoCardSucceeded,
      testMagentoCardFailed,
    ),
  ),
  takeLatest(
    editMagentoCard.toString() as any,
    genWithPromise(
      api.editCustomCard,
      editMagentoCardSucceeded,
      editMagentoCardFailed,
    ),
  ),
  takeLatest(
    removeMagentoCard.toString() as any,
    genWithPromise(
      api.removeCustomCard,
      removeMagentoCardSucceeded,
      removeMagentoCardFailed,
    ),
  ),
  takeLatest(
    addMagentoCard.toString() as any,
    genWithPromise(
      api.addCustomCard,
      addMagentoCardSucceeded,
      addMagentoCardFailed,
    ),
  ),
];

function genWithPromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    try {
      result = yield call(apiAction, action.payload);
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}
